import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Footer from '../components/Footer'

export default function NotFound() {
    const navigate = useNavigate()
    return (
        <div>
            <div className="max-w-[50rem] flex flex-col mx-auto md:h-[89vh] h-[88vh] size-full ">
                <div>

                    <header className="mb-auto flex justify-center z-50 w-full py-4">
                        <nav className="px-4 sm:px-6 lg:px-8" aria-label="Global">
                            <button className="flex-none text-xl font-semibold sm:text-3xl dark:text-white" aria-label="Brand">Pagina não encontrada</button>
                        </nav>
                    </header>

                    <main id="content">
                        <div className="text-center py-10 px-4 sm:px-6 lg:px-8">
                            <h1 className="block text-7xl font-bold text-gray-800 sm:text-9xl dark:text-white">404</h1>
                            <p className="mt-3 text-gray-600 dark:text-neutral-400">Ops, algo deu errado.</p>
                            <p className="text-gray-600 dark:text-neutral-400">Desculpe, não conseguimos encontrar sua página.</p>
                            <div className="mt-5 flex flex-col justify-center items-center gap-2 sm:flex-row sm:gap-3">
                                <button
                                    onClick={() => navigate(-1)}
                                    className="w-full bg-primary text-white py-3 px-4 rounded-lg hover:bg-primary-dark transition-colors duration-200 max-w-28 " >
                                    Voltar
                                </button>
                            </div>
                        </div>
                    </main>
                </div>


            </div>
            <Footer />

        </div>
    )
}
